<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>
        <div class="row no-gutters">
            <div class="col-md-7  d-flex">
                <span class="label">{{subscription.bundle.name}}</span>
            </div>
            <div class="col-md-5 d-flex">
                <span class="value modal-subtitle"
                      [ngClass]="{'modal-subtitle-upcoming-deactivation':subscription.endDate!==null}"
                      *ngIf="subscription.active">
                    Activated on: {{subscription.startDate|customDate}}
                    <div *ngIf="subscription.endDate!==null">Upcoming deactivation</div>
                </span>
                <span class="value modal-subtitle-upcoming" *ngIf="!subscription.active">Upcoming activation</span>
            </div>
        </div>
    </ng-container>

    <ng-container dialog-process-in-progress
                  *ngIf="form && form.formGroup">

        <div class="col-12">
            <span class="value  modal-subtitle">Assigned To {{isServiceUser ? 'Service user' : 'Account'}}</span>
        </div>
        <div class="col-12 mb-lg-2">
                <span class="value">
                    {{clientAccountAndBundleData.accountReferenceId}} ({{clientAccountAndBundleData.userFullName}})
                </span>
        </div>

        <div class="col-12">
            <span class="label modal-row-title">Product Description</span>
        </div>
        <div class="col-12 mb-lg-2">
                <span class="value">
                    {{subscription.bundle.description}}
                </span>
        </div>

        <form [formGroup]="form.formGroup" class="row edit-subscription-form">
            <div *ngIf="!isServiceUser && hasViewSubscriptionPrice" class="col-12">
                <div *ngIf="!hasSetSubscriptionPrice" class="col-12">
                    <span class="label modal-row-title">Price</span>
                </div>
                <div *ngIf="!hasSetSubscriptionPrice" class="col-12 mb-lg-2">
                <span class="value">
                    $ {{subscription.price | formatDecimal}}
                </span>
                </div>
                <div *ngIf="hasSetSubscriptionPrice" [ngClass]="{'mb-3': form.controls[0].errors?.length > 0}"
                    class="col-12">
                   <span class="value">
                           <app-amount-input
                               [formControlName]="form.controls[0].name"
                               [control]="form.controls[0]"
                           ></app-amount-input>
                   </span>
               </div>
                <div *ngIf="hasSetSubscriptionPrice" [ngClass]="{'mb-3': form.controls[4].errors?.length > 0}"
                     class="col-12">
                    <span class="value">
                            <app-select
                                [formControlName]="form.controls[4].name"
                                [control]="form.controls[4]"
                            ></app-select>
                    </span>
                </div>
            </div>

            <div *ngIf="!isServiceUser" class="col-12" appCheckPermissionRule [rule]="setMarkupPermission">
                <div [ngClass]="{'mb-3': form.controls[1].errors?.length > 0}" class="col-12">
                    <span class="value">
                            <app-amount-input
                                [formControlName]="form.controls[1].name"
                                [control]="form.controls[1]"
                            ></app-amount-input>
                    </span>
                </div>
            </div>

            <div class="col-12" *ngIf="!subscription.active">
                <div [ngClass]="{'mb-3': form.controls[2].errors?.length > 0}" class="col-12">
                    <span class="value">
                            <app-datepicker
                                [formControlName]="form.controls[2].name"
                                [control]="form.controls[2]"
                            ></app-datepicker>
                    </span>
                </div>
            </div>

            <div class="col-12">
                <div [ngClass]="{'mb-3': form.controls[3].errors?.length > 0}" class="col-12">
                    <span class="value">
                            <app-datepicker
                                [formControlName]="form.controls[3].name"
                                [control]="form.controls[3]"
                            ></app-datepicker>
                    </span>
                </div>
            </div>

        </form>
    </ng-container>

</app-dialog>
